/**
 * Dev-only console wrapper. In production builds these are no-ops so we
 * don't ship noisy console output to end users, while retaining
 * observability locally and in preview.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn:  (...args) => { if (isDev) console.warn(...args); },
  info:  (...args) => { if (isDev) console.info(...args); },
};
